export const ANOMALY_EXPORT_TITLE_FULL_TEXT = "Full Anomaly Table export";
export const ANOMALY_EXPORT_TITLE_FULL_DESCRIPTION_TEXT =
  "Since you don't have active filters, you are exporting the Full Anomaly Table, this might take some time. To reduce exporting time, apply at least one filter.";
export const ANOMALY_EXPORT_TITLE_ACTIVE_TEXT = "Filters active";
export const ANOMALY_EXPORT_SUB_TITLE_ACTIVE_TEXT =
  "Your active filters will be applied to this data export, if this are not the parameters you want consider cleaning all filters first.";
export const ANOMALY_EXPORT_TITLE_ACTIVE_DESCRIPTION_TEXT =
  "Your export will include the following filters, if you want to export the entire table, make sure no filters are active here:";
export const ALERT_ICON_TEST_ID = "alert-icon";
